import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealFile";

export function selectByDealId(dealId){
  return axios({
    url: `/ws/${moduleName}/selectByDealId/${dealId}`,
    method: 'get',
  })
}

export function batchInsertDealFiles(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/batchInsert`,
    method: 'post',
    data:parameter
  })
}

export function deleteFile(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'delete',
    data:parameter
  })
}

export default {
  selectByDealId,
  batchInsertDealFiles,
  deleteFile,
}